import React, { useMemo } from 'react';
import { Typography, Tag, Button, message } from 'antd';
import { UpCircleOutlined } from '@ant-design/icons';
import { useQueryClient } from '@tanstack/react-query';
import CrudPage from '../../../components/common/CrudPage';
import { apiVersionService } from '../../../services/next';

const { Text } = Typography;

const QUERY_KEY = 'apiVersionList';

const QuanLyVersionAPI = () => {
  const queryClient = useQueryClient();

  const handleUpdateVersion = async (id) => {
    try {
      const res = await apiVersionService.update(id, {});
      if (res && res.code === 200) {
        message.success('Cập nhật version thành công');
        queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
      } else {
        message.error(res?.message || 'Cập nhật thất bại');
      }
    } catch (error) {
      message.error('Lỗi khi cập nhật version');
    }
  };

  const columns = useMemo(
    () => [
      { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
      { title: 'TÊN API / VỊ TRÍ HIỂN THỊ', dataIndex: 'name', key: 'name', render: (t) => <Text strong>{t}</Text> },
      { title: 'ĐƯỜNG DẪN (API)', dataIndex: 'api', key: 'api' },
      {
        title: 'VERSION HIỆN TẠI',
        dataIndex: 'version',
        key: 'version',
        width: 160,
        render: (v) => <Tag color="blue" style={{ fontSize: 14, padding: '4px 10px' }}>{v}</Tag>,
      },
    ],
    []
  );

  // CMS cũ cho phép thêm dòng cache_api mới; chỉ sửa version qua nút "Cập nhật +1"
  // nên form chỉ gồm các trường lúc tạo.
  const formFields = useMemo(
    () => [
      {
        name: 'name',
        label: 'Tên API / Vị trí hiển thị',
        type: 'input',
        rules: [{ required: true, message: 'Vui lòng nhập tên API!' }],
      },
      {
        name: 'api',
        label: 'Đường dẫn (API)',
        type: 'input',
        placeholder: 'VD: /json/api/cards/get-cards',
        rules: [{ required: true, message: 'Vui lòng nhập đường dẫn API!' }],
      },
      { name: 'version', label: 'Version khởi tạo', type: 'number', defaultValue: 1, propsInput: { min: 1 } },
    ],
    []
  );

  const customActions = (record) => (
    <Button type="primary" icon={<UpCircleOutlined />} size="small" onClick={() => handleUpdateVersion(record.id)}>
      Cập nhật +1
    </Button>
  );

  return (
    <CrudPage
      title="QUẢN LÝ VERSION API"
      subTitle="Quản lý version cache API của ứng dụng"
      itemsName="Version API"
      queryKey={QUERY_KEY}
      service={apiVersionService}
      columns={columns}
      formFields={formFields}
      searchPlaceholder="Tìm kiếm theo tên / đường dẫn API..."
      addButtonLabel="Tạo mới"
      disableEdit
      disableDelete
      disableCopy
      customActions={customActions}
    />
  );
};

export default QuanLyVersionAPI;
